import moment from 'moment-timezone';

const timezoneConvertor = (date, timezone) => { 
    return (new Date(moment.utc(date).tz(timezone).format('YYYY/MM/DD HH:mm:ss'))) ; 
};

const dateTimeConvertor = (timezone, date) => {
    return moment.utc(date).tz(timezone);
}

const localeData = (locale) => {
    return moment.localeData(locale);
}

const formatDateTime = (date, format) => {
    return moment(date).format(format);
}
const formatDateOnly = (date, format) => {
    return moment.utc(date).format(format);
}

export const momentUtil = {
    timezoneConvertor,
    dateTimeConvertor,
    localeData,
    formatDateTime,
    formatDateOnly
};